"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRE_BUILD_UKMLA_MARKSHEET = exports.UKMLA_TOPICS = exports.UKMLA_TOPIC = void 0;
const client_1 = require("@apollo/client");
exports.UKMLA_TOPIC = (0, client_1.gql) `
  query UkmlaTopic($id: Int!) {
    restricted {
      ukmlaTopic(id: $id) {
        id
        name
        totalQuestions
        correctQuestions
        incorrectQuestions
        conditions {
          id
          name
          totalQuestions
          correctQuestions
          incorrectQuestions
          topicId
          questionIds
          topic {
            id
            name
          }
        }
        presentations {
          id
          name
          totalQuestions
          correctQuestions
          incorrectQuestions
          topicId
          questionIds
          topic {
            id
            name
          }
        }
      }
    }
  }
`;
exports.UKMLA_TOPICS = (0, client_1.gql) `
  query UkmlaTopics($order: Int) {
    restricted {
      ukmlaTopics(order: $order) {
        id
        name
        demo
        totalQuestions
        correctQuestions
        incorrectQuestions
        conditions {
          id
          name
          demo
          totalQuestions
          correctQuestions
          incorrectQuestions
          concepts {
            id
            name
            topicId
            chapterId
          }
          questionIds
          topic {
            id
            name
          }
        }
        presentations {
          id
          name
          demo
          totalQuestions
          correctQuestions
          incorrectQuestions
          questionIds
          topic {
            id
            name
          }
        }
      }
    }
  }
`;
exports.PRE_BUILD_UKMLA_MARKSHEET = (0, client_1.gql) `
  query PreBuildUkmlaMarksheet(
    $topicIds: [Int!]
    $conditionIds: [Int!]
    $presentationIds: [Int!]
    $source: String!
    $search: String
    $marksheetId: Int
    $difficulty: [Int!]
    $useAI: Boolean
  ) {
    restricted {
      preBuildUkmlaMarksheet(
        topicIds: $topicIds
        conditionIds: $conditionIds
        presentationIds: $presentationIds
        source: $source
        search: $search
        marksheetId: $marksheetId
        difficulty: $difficulty
        useAI: $useAI
      ) {
        unseen
        seenCorrect
        seenIncorrect
        buildRef
      }
    }
  }
`;
